module.exports = "/images/helpCall.svg";